import {useState} from "react";
import {throttleCount} from "../utils/globals";

export const useLoadingFetcher = () => {
  const [count, setCount] = useState(0);
  return {
    pushApiCount: () => setCount(c => c + 1),
    popApiCount: () => setCount(c => Math.max(c - 1, 0)),
    isLoading: count > 0,
    isThrottled: count > throttleCount,
  };
}
